<template>
  <div style="width: 100%;">
    <div v-if="files.length > 1" style="width: 11%; float: right; height: 30px">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="trashFiles"
            icon
            text
            color="accent"
            x-small
            class="ma-0"
            v-bind="attrs"
            v-on="on"
            outlined
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $tc("DeleteAll") }}</span>
      </v-tooltip>
    </div>
    <div style="min-height: 77px; width: 100%">
      <label v-if="label">{{ label }}</label>
      <div
        v-if="files.length === 0"
        class="file-input-container"
        :class="{ disabled: disabled }"
      >
        <input
          type="file"
          ref="file"
          class="file-input"
          :accept="acceptedFileTypes"
          :disabled="disabled"
          @change="onFileChange"
          :multiple="multipleFiles"
        />
        <div class="file-input-content flex-horizontal">
          <v-icon class="custom-icon">mdi-cloud-upload</v-icon>
          <span class="drop-file-message">{{ $t("DropFile") }}</span>
        </div>
      </div>
      <div
        v-if="files.length === 0 && fileTypesAsString !== ''"
        id="file-valid-type"
      >
        {{ $t("FileTypeMustBe") + fileTypesAsString + "." }}
      </div>
      <div
        v-if="files.length !== 0"
        v-for="(file, index) of files"
        :key="file.name"
        style="width: 100%"
      >
        <div class="file-input-container file-content">
          <span>{{ file.name }}</span>
          <TrashSVG id="trash-icon" @click="trashFile(index)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadSVG from "@/assets/management/drop.svg";
import TrashSVG from "@/assets/management/trash.svg";
import { bus } from '../../main';
export default {
  name: "DropFileArea",

  components: {
    UploadSVG,
    TrashSVG
  },

  props: {
    /**
     * Determines the component title
     */
    label: {
      type: String
    },

    /**
     * Determines whether the send button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: true
    },

    /**
     * Determines the type of files the user can send
     */
    fileTypes: {
      type: Array,
      required: true
    },

    /**
     * Determines if the user can send more than one file
     */
    multipleFiles: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      /**
       * Stores the files that the user has uploaded
       */
      files: [],
      yourColorVariable: '#767676',
    };
  },

  mounted(){
    bus.$on("clear-drop-button-file", this.clearFile);
    bus.$on("delete-all-files", this.trashFiles);
  },

  destroyed(){
    bus.$off("clear-drop-button-file");
    bus.$off("delete-all-files");
  },

  computed: {
    /**
     * Returns file types as string
     * @returns {string}
     */
    fileTypesAsString() {
      let types = "";
      let nrOfFileTypes = this.fileTypes.length;
      for (let i = 0; i < nrOfFileTypes; i++) {
        types += this.fileTypes[i];
        if (i < nrOfFileTypes - 1) {
          types += " or ";
        }
      }
      return types;
    },

    /**
     * Returns accepted file types
     * @returns {string}
     */
    acceptedFileTypes() {
      let types = "";
      let nrOfFileTypes = this.fileTypes.length;
      for (let i = 0; i < nrOfFileTypes; i++) {
        types += this.fileTypes[i];
        if (i < nrOfFileTypes - 1) {
          types += ",";
        }
      }
      return types;
    }
  },

  methods: {
    clearFile(){
      this.files = [];
    },

    /**
     * Updates the local file when a new file is uploaded.
     */
    onFileChange() {
      let files = [];
      files = this.$refs.file.files;
      if (!files) {
        return;
      }
      for (let i = 0; i < files.length; i++) {
        if (this.fileIsOfValidType(files[i].name)) {
          this.files.push(files[i]);
        } else {
          this.trashFiles();
          this.$toasted.global.toast_error(
            files[i].name +
              " - " +
              this.$i18n.t("WrongFileTypeWarning") +
              this.fileTypesAsString +
              "."
          );
          break;
        }
      }
      if (files.length === 1) {
        this.$emit("updateFile", files[0]);
      } else {
        this.$emit("updateFile", files);
      }
    },

    /**
     * Eliminate file stored locally
     * and emit an event to the parent component to inform
     */
    trashFile(index) {
      this.files.splice(index, 1);
      if (this.files.length === 0) {
        this.$emit("trashFile");
      }
    },

    /**
     * Delete all locally stored files
     * and emit an event to the parent component to inform
     */
    trashFiles() {
      this.files = [];
      this.$emit("trashFile");
    },

    /**
     * Checks if an uploaded file is of one of the valid types.
     * @param {String} fileName - name of the uploaded file
     * @returns {boolean}
     */
    fileIsOfValidType(fileName) {
      for (let i = 0; i < this.fileTypes.length; i++) {
        if (fileName.includes(this.fileTypes[i])) return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.file-input-container {
  width: 100%;
  height: 70px;
  padding: 5px;
  position: relative;
  border: 1px dashed #acacae;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #767676;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.82px;
}
.file-input-container.disabled {
  color: #767676;
}
.file-input-container.disabled #upload-icon path {
  fill: #767676;
}

.file-input-content {
  width: 50%;
  height: 100%;
  padding: 4%;
  align-items: center;
  justify-content: center;
}
.file-input {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}

#upload-icon {
  height: 13px;
  margin-right: 8px;
}

#file-valid-type {
  margin: 5px;
  text-align: center;
  font-size: 8px;
  font-weight: 500;
  letter-spacing: 0.52px;
  color: #767676;
}

.file-content {
  padding: 4%;
  justify-content: space-between;
  border-style: solid;
  font-size: 12px;
  color: #767676;
}
#trash-icon {
  height: 15px;
  margin-left: 4%;
  cursor: pointer;
}

#trash-icon path {
  fill: #767676;
}

.drop-file-message {
  font-weight: 600;
  font-size: 10px;
  text-align: center;
}

.custom-icon{
  color:#767676;
  margin-right: 0.51rem;
}
</style>



// WEBPACK FOOTER //
// src/components/_Molecules/DropFileArea.vue